import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography, getContrastRatio } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../redux/commonSlice";
import { eventVideoUploadConsent } from "../../../services/api";
import { useMutation } from "react-query";
import useEventList from "../../dashboard/hooks/useEventList";
import { LoadingButton } from "@mui/lab";
import CustomAlert from "../../events/components/CustomAlert";
import CustomInput from "../../eventcreation/components/CustomInput";
// import { customTheme as theme } from "../../../theme/customTheme";
import useCustomTheme from "../../../theme/useCustomTheme";
import { generateLighterContrastColor } from "../../../utils/commonServices";

const EditingNotStartedPopup = (props) => {
    const {deleteUserHandler, status} = props
    const [closeHandler, setCloseHandler] = useState(false)
    const isDisabled = false
    const dispatch = useDispatch()
    const commonReducer = useSelector(state=> state.root.commonReducer)
 
    const [text, setText] = useState("")
    const [theme ] = useCustomTheme()

    const handleClose = () => {
        dispatch(updateState({editing_not_started_popup : false})) 
       };

       


  

    const cancelHandler =()=>{
      handleClose();
    }
  

  return (
    
        <CustomAlert 
          open={commonReducer.editing_not_started_popup} 
          handleClose={handleClose} 
          width={{xs:'400px',sm:'400px',md:'420px',lg:'440px', xl:'600px'}}
          height={{xs:'250px',sm:'260px',md:'290px',lg:'300px', xl:'380px'}}
        >
           <Box p={5} className="flex col j-center" sx={{ height:'100%'}}>
          
            <Box   mb={{xs:1 ,md:2}} mt= {1}>
              <Typography variant="h4" sx={{fontFamily:'Rubik', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>{`Editing not started for this project.`}</Typography>
            </Box>
    
    
            <Box sx={{display:'flex',justifyContent:'end' }} gap={2} mt={{xs:1 ,md:2}} >
    
              {/* <Button variant='outlined' color="button" onClick={cancelHandler} style={{borderRadius: '5px', color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main), textTransform:'none', }} sx={{fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'}, paddingY:0.4,}}>Cancel</Button> */}
    
              <LoadingButton
                   // size="small"
                  
                    onClick={cancelHandler}
                    style={{borderRadius: '5px', backgroundColor:'#08231B',color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main), textTransform:'none' }} 
                    sx={{ fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'}, minWidth: '110px !important'}}
                    loading={status == 'loading'}
                    loadingPosition="start"
                    variant="contained"
                    >
                   Cancel
               </LoadingButton> 
            </Box>
           </Box>
        </CustomAlert>
      
  )
}

export default EditingNotStartedPopup